<template>
	<div class="category page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<!-- 编辑信息 -->
		<el-dialog title="编辑分类" :visible.sync="dialogFormVisible" width="500px" custom-class="generalDialog">
			<el-form ref="categoryForm" :model="categoryForm" :label-width="categoryFormLabelWidth"
				:rules="categoryFormRules">
				<el-form-item label="分类名称" prop="name">
					<el-input v-model="categoryForm.name" autocomplete="off" placeholder="请输入分类名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="父级分类" prop="parent">
					<el-select v-model="categoryForm.parent" placeholder="请选择父级分类" clearable>
						<el-option v-for="(item,index) in parentList" :key="index" :label="item.articleTypeName"
							:value="item.articleTypeId">
						</el-option>
					</el-select>
					<div class="hint">
						如添加一级分类，请勿选择父级。<br>
						如添加二级分类，请选择父级
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="DialogClose">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="DialogConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'category',
		data() {
			return {
				dialogFormVisible: false,
				categoryForm: {
					name: '',
					parent: ''
				},
				parentList: [],
				categoryFormLabelWidth: '80px',
				categoryFormRules: {
					name: [{
						required: true,
						trigger: 'blur',
						message: '请输入分类名称'
					}]
				},
				loading: false,
				// 表格
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加分类',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'articleTypeName',
							label: '分类名称',
							width: 250
						},
						{
							prop: 'articleTypeLevel',
							label: '分类级别',
							width: 250,
							template: true
						},
						{
							prop: 'parentId',
							label: '父级分类',
							width: 250
						},
						{
							prop: 'createAt',
							label: '创建时间',
							width: 250
						}
					],
					tableEvent: [{
							icon: 'el-icon-edit',
							name: '编辑',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				operationId: ''
			};
		},
		methods: {
			pageChange() {

			},
			buttonClick(sign) {
				if (sign === 'new') {
					this.dialogFormVisible = true
				}
			},
			filterChange() {
				console.log(this.filterValue);
			},
			scopeButtonClick(row, sign) {
				this.operationId = row.articleTypeId
				if (sign === 'edit') {
					this.categoryForm = {
						name: row.articleTypeName,
						parent: row.parentId == 0 ? '' : row.parentId
					}
					this.dialogFormVisible = true
				}
				if (sign === 'delete') {
					this.$confirm('确认要删除这个分类吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.articleCategoryDelete({
							id: this.operationId
						}, res => {
							this.operationId = ''
							if (res.code == 200) {
								this.fetchData()
								this.fetchCategoryAll()
								this.$message({
									message: '删除成功',
									type: 'success',
									duration: 2000
								})
							}
						})
					}).catch(() => {});
				}
			},
			DialogClose() {
				this.operationId = ''
				this.categoryForm = {
					parent: '',
					name: ''
				}
				this.dialogFormVisible = false
			},
			DialogConfirm() {
				this.$refs.categoryForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$api.articleCategoryAdd({
							parentId: this.categoryForm.parent == '' ? 0 : this.categoryForm.parent,
							articleTypeName: this.categoryForm.name,
							articleTypeId: this.operationId,
							articleTypeLevel: this.categoryForm.parent == '' ? 1 : 2
						}, res => {
							this.loading = false
							if (res.code == 200) {
								this.$message({
									message: (this.operationId == '' ? '新增' : '编辑') + '分类成功！',
									duration: 2000,
									type: 'success',
									onClose: () => {

									}
								})
								this.DialogClose()
								this.fetchData()
								this.fetchCategoryAll()
							}
						})
					}
				})
			},
			fetchData() {
				this.$api.articleCategory({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchCategoryAll(){
				this.$api.articleCategoryAll({},res=>{
					if(res.code==200){
						this.parentList = res.data
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.fetchData()
			this.fetchCategoryAll()
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.hint {
		width: 100%;
		line-height: 20px;
		padding-top: @vue-spacing-col-sm;
		font-size: @vue-font-size-min;
		box-sizing: border-box;
		color: @vue-text-color-red;
	}
</style>
